import { Events } from "@type-r/models";
import * as React from "react";
import { asCurrency, Tile, TileField, asTimelessDate } from "lqx-react";
import { ExpiredQuote, OrderModel } from "../../../../api";
import { OrderStateFlow, orderStatusColor } from "./common";

export const ExpiredQuoteTile = ({ data, style, index }) => {
  const quote: ExpiredQuote = data.items[index];

  return (
    <Tile style={style} color={orderStatusColor("Expired")} title={quote.id}>
      <TileField label="Created:">{asTimelessDate(quote.quote_date)}</TileField>
      <TileField label="Expired:">
        {asTimelessDate(quote.expiry_date)}
      </TileField>
    </Tile>
  );
};

export const OrderTile = ({ data, style, index }) => {
  const order: OrderModel = data.items[index];
  const { displayFlags } = order;

  return (
    <Tile
      $checked={undefined /* $checked */}
      onClick={() => Events.trigger("navigate", `/orders/${order.id}`)}
      style={style}
      color={orderStatusColor(order.status)}
      leftTitle={order.status}
      left={
        <TileField>
          {order.po_details.po_date
            ? asTimelessDate(order.po_details.po_date)
            : `-`}
        </TileField>
      }
      title={order.title}
      right={<OrderStateFlow order={order} />}
    >
      <TileField label="PO #">{order.po_number}</TileField>

      <TileField label="SO #">{order.sales_order_id}</TileField>

      <TileField label="QUOTE #">{order.quote.id}</TileField>

      <TileField label="TOTAL PRICE">{asCurrency(order.total_price)}</TileField>

      {displayFlags ? (
        <TileField label="FLAGS" long>
          {order.displayFlags}
        </TileField>
      ) : null}
    </Tile>
  );
};
